<script setup lang="ts">
import { useI18n } from "vue-i18n";

import IconCross from "@/components/icons/white/IconWhiteCross.vue";

const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div class="search-info-box">
    <div class="search-info-box__item search-info-box__label" aria-hidden="true">
      {{ t("article.search-info-box.label") }}
    </div>
    <div class="search-info-box__item search-info-box__text">
      <span><slot /></span>
    </div>
    <div class="search-info-box__item">
      <button
        type="button"
        class="search-info-box__close-button"
        :aria-label="t('article.search-info-box.close')"
        @click="emit('close')"
      >
        <IconCross class="search-info-box__close-button-icon" role="presentation" />
      </button>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.search-info-box {
  display: flex;
  align-items: stretch;
  justify-content: center;
  min-height: 40px;
  border-radius: 2px;
  background: white;
  font-size: 1.125rem;
  word-wrap: break-word;
  hyphens: auto;

  &__item {
    display: flex;
    align-items: center;
  }

  &__label {
    padding: 0 26px;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    background: rgb(@theme-colors[@primary][base]);
    color: white;
    font-weight: 700;
  }

  &__text {
    flex-grow: 1;
    margin-left: 8px;

    #media-breakpoint-up(md, {
      margin-left: 22px;
    });
  }

  &__close-button {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    margin: 0 12px;
    padding: 0;
    border: none;
    border-radius: 100%;
    background: none;
    color: black;
    cursor: pointer;

    &:focus,
    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }

    &:focus {
      outline: 1px solid black;
    }

    &-icon {
      width: 10px;
      height: 10px;
    }
  }
}
</style>
